//15、锁孔
import makerjs from "makerjs";
// inputParam,model,myHolesNum,outParam,fixedParam
// (D,X,Y,area,plate,markers,myHolesNum,glassW,glassH,markShift,markShiftTwo,markShiftThree,markShiftFour,markHolesOneD)
function KeyHole(inputParam, model, myHolesNum, outParam, fixedParam, zoom, θCut, rCut,cutLine,cutFilletRadius){
var D1=inputParam.D1,D2=inputParam.D2,W=inputParam.W,H=inputParam.H,X=inputParam.X,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
plate = model.plate, cutPlate = model.cutPlate, markers = model.markers,
glassW=outParam.glassW,glassH=outParam.glassH,
   markShift=fixedParam.markShift*1,markShiftTwo=fixedParam.markShiftTwo*1,
   markShiftThree=fixedParam.markShiftThree*1,markShiftFour=fixedParam.markShiftFour*1,markHolesOneD=fixedParam.markHolesOneD*1,
 
   d1 = D1*1*myZoom,
      d2 = D2*1*myZoom,
      w= W*1*myZoom,
      h= H*1*myZoom,
        x0 = X*1*myZoom,
        y0 = Y*1*myZoom;
        if(plate.models===undefined||plate.models===""){
            console.log("1111111111111111");
            plate.models={};
                    }        
                    if(cutPlate.models===undefined||cutPlate.models===""){
                        console.log("22222222222");
                        //cutPlate.models={};
                        cutPlate.models={};
                    }
                    if(markers.models===undefined||markers.models===""){            
                        console.log("333333333333");
                        markers.models={};
                    }
        /*
        d1 = D1*1,
           d2 = D2*1,
           w= W*1,
           h= H*1,
             x0 = X*1,
             y0 = Y*1;
             */
        if(d1!==0){
         var TxtD1="∮"+D1;
        }
        if(d2!==0){
         var TxtD2="∮"+D2;
        }
        if(h!==0){
         var TxtH=H;
        }
        if(w!==0){
         var TxtW=W;
        }
        if(x0!==0){          
        var TxtX=X;
        }
        if(y0!==0){          
         var TxtY=Y;
        }
  //在A区域 计算孔的位置       
  var xa=x0,ya=glassH * 1-y0,
  //B区域//只有Y标注没有X标注 
  xb=glassW * 1/2,yb=glassH * 1-y0,
  //C区域
  xc=glassW * 1-x0,yc=glassH * 1-y0,
  //D区域
  //只有X标注没有Y标注 
  xd=x0,yd=glassH * 1/2,
  //E区域
  //只有X标注没有Y标注 
  xe=glassW * 1/2,ye=glassH * 1/2,
  //F区域
  //只有X标注没有Y标注 
  xf=glassW * 1-x0,yf=glassH * 1/2,
  //在G区域 计算孔的位置
  xg=x0,yg=y0,
  //在H区域 计算孔的位置
  //只标注Y
  xh=glassW*1/2,yh=y0,
  //在I区域 计算孔的位置
  xi=glassW*1-x0,yi=y0;

  
if(glassW*1>glassH * 1){
      console.log("长边在X轴￥￥￥￥￥");
if(area==2){
            //画孔 B位置孔
                 //标记锁孔B位置孔左上
                 var myKhHolesBLeftup= new makerjs.models.Holes(d1/2, [[xb-w, yb]]);
                 var myKhHolesMarkBLeftup = new makerjs.models.Square(0); //孔的原点       
                 myKhHolesMarkBLeftup.origin = [xb-w, yb];      
                 var myKhHolesXMarkBLeftup = new makerjs.models.Square(0);      
                 myKhHolesXMarkBLeftup.origin =[xb-w, yb];      
                 var myKhHolesYMarkBLeftup = new makerjs.models.Square(0);      
                 myKhHolesYMarkBLeftup.origin = [xb-w, yb]; 
           /*****************************************************************************/ 
           makerjs.model.addPath(myKhHolesMarkBLeftup, new makerjs.paths.Line([0,0], [d1, -d1]));//直径标线
           makerjs.model.addCaption(myKhHolesMarkBLeftup, TxtD1, [0,0], [d1+markHolesOneD, -d1-markHolesOneD]);//直径文字标注
           /*****************************************************************************/   
           makerjs.model.addPath(myKhHolesXMarkBLeftup, new makerjs.paths.Line([0,0], [0, y0]));//X短标线
           makerjs.model.addCaption(myKhHolesXMarkBLeftup, TxtY,[0-markShift,0], [0-markShift, y0]);//X文字标注
           /*****************************************************************************/ 
           makerjs.model.addPath(myKhHolesYMarkBLeftup, new makerjs.paths.Line([0,0], [w, 0]));//X短标线
           makerjs.model.addCaption(myKhHolesYMarkBLeftup, TxtW, [0,0+markShift], [w, 0+markShift]);//X文字标注
           /*****************************************************************************/ 
           //  //标记锁孔B位置孔右中
            var myKhHolesBRightmd= new makerjs.models.Holes(d2/2, [[xb, yb-h]]);
                 var myKhHolesMarkBRightmd = new makerjs.models.Square(0); //孔的原点       
                 myKhHolesMarkBRightmd.origin = [xb, yb-h];      
                 var myKhHolesXMarkBRightmd = new makerjs.models.Square(0);      
                 myKhHolesXMarkBRightmd.origin =[xb, yb-h];      
                 var myKhHolesYMarkBRightmd = new makerjs.models.Square(0);      
                 myKhHolesYMarkBRightmd.origin = [xb, yb-h];  
           /*****************************************************************************/ 
           makerjs.model.addPath(myKhHolesMarkBRightmd, new makerjs.paths.Line([0,0], [d2, -d2]));//直径标线
           makerjs.model.addCaption(myKhHolesMarkBRightmd, TxtD2, [0,0], [d2+markHolesOneD, -d2-markHolesOneD]);//直径文字标注
           /*****************************************************************************/   
           makerjs.model.addPath(myKhHolesXMarkBRightmd, new makerjs.paths.Line([0,0+h], [w, 0+h]));//X短标线
           makerjs.model.addCaption(myKhHolesXMarkBRightmd, TxtW, [0,0+markShift+h], [w, 0+markShift+h]);//X文字标注
           /*****************************************************************************/     
           makerjs.model.addPath(myKhHolesYMarkBRightmd, new makerjs.paths.Line([0,h], [0, 0]));//H短标线
           makerjs.model.addCaption(myKhHolesYMarkBRightmd, TxtH,[0-markShift,0], [0-markShift, h]);//H文字标注
           /*****************************************************************************/ 
           /*****************************************************************************/ 
            //标记锁孔B位置孔左下
            var myKhHolesBLeftdn= new makerjs.models.Holes(d1/2, [[xb+w, yb]]);     
            var myKhHolesMarkBLeftdn = new makerjs.models.Square(0); //孔的原点       
            myKhHolesMarkBLeftdn.origin = [xb+w, yb];      
            makerjs.model.addPath(myKhHolesMarkBLeftdn, new makerjs.paths.Line([0,0], [d1, -d1]));//直径标线
           makerjs.model.addCaption(myKhHolesMarkBLeftdn, TxtD1, [0,0], [d1+markHolesOneD, -d1-markHolesOneD]);//直径文字标注
           /*****************************************************************************/ 
           plate.models["TypeHoles_KeyHole_BLeftup"+myHolesNum]=myKhHolesBLeftup;
           cutPlate.models["TypeHoles_KeyHole_BLeftup"+myHolesNum]=myKhHolesBLeftup;
           markers.models["TypeHoles_KeyHole_BLeftup"+myHolesNum]=myKhHolesBLeftup;
           markers.models["TypeHoles_KeyHole_MarkBLeftup"+myHolesNum]=myKhHolesMarkBLeftup;
           markers.models["TypeHoles_KeyHole_XMarkBLeftup"+myHolesNum]=myKhHolesXMarkBLeftup;
           markers.models["TypeHoles_KeyHole_YMarkBLeftup"+myHolesNum]=myKhHolesYMarkBLeftup;
           /*****************************************************************************/
           plate.models["TypeHoles_KeyHole_BLeftdn"+myHolesNum]=myKhHolesBLeftdn;
           cutPlate.models["TypeHoles_KeyHole_BLeftdn"+myHolesNum]=myKhHolesBLeftdn;
           markers.models["TypeHoles_KeyHole_BLeftdn"+myHolesNum]=myKhHolesBLeftdn;
           markers.models["TypeHoles_KeyHole_MarkBLeftdn"+myHolesNum]=myKhHolesMarkBLeftdn;
           /*****************************************************************************/ 
           plate.models["TypeHoles_KeyHole_BRightmd"+myHolesNum]=myKhHolesBRightmd;
           cutPlate.models["TypeHoles_KeyHole_BRightmd"+myHolesNum]=myKhHolesBRightmd;
           markers.models["TypeHoles_KeyHole_BRightmd"+myHolesNum]=myKhHolesBRightmd;
           markers.models["TypeHoles_KeyHole_MarkBRightmd"+myHolesNum]=myKhHolesMarkBRightmd;
           markers.models["TypeHoles_KeyHole_XMarkBRightmd"+myHolesNum]=myKhHolesXMarkBRightmd;
           markers.models["TypeHoles_KeyHole_YMarkBRightmd"+myHolesNum]=myKhHolesYMarkBRightmd;
           /*****************************************************************************/ 
          
}else if(area==8){
           //画孔H位置孔
                 //标记锁孔H位置孔右上
                 var myKhHolesHRightup= new makerjs.models.Holes(d1/2, [[xh-w, yh]]);
                 var myKhHolesMarkHRightup = new makerjs.models.Square(0); //孔的原点       
                 myKhHolesMarkHRightup.origin = [xh-w, yh];      
                 var myKhHolesXMarkHRightup = new makerjs.models.Square(0);      
                 myKhHolesXMarkHRightup.origin =[xh-w, yh];      
                 var myKhHolesWMarkHRightup = new makerjs.models.Square(0);      
                 myKhHolesWMarkHRightup.origin =[xh-w, yh]; 
           /*****************************************************************************/ 
           makerjs.model.addPath(myKhHolesMarkHRightup, new makerjs.paths.Line([0,0], [0, -y0]));//从孔圆心出发X方向横向标线
           makerjs.model.addPath(myKhHolesMarkHRightup, new makerjs.paths.Line([0,0], [w, 0]));//X轴加长标线
           /*****************************************************************************/ 
           makerjs.model.addPath(myKhHolesMarkHRightup, new makerjs.paths.Line([0,0], [d1, -d1]));//直径标线
           makerjs.model.addCaption(myKhHolesMarkHRightup, TxtD1, [0,0], [d1+markHolesOneD, -d1-markHolesOneD]);//直径文字标注
           /*****************************************************************************/   
           makerjs.model.addPath(myKhHolesXMarkHRightup, new makerjs.paths.Line([0,-y0], [0, 0]));//X短标线
           makerjs.model.addCaption(myKhHolesXMarkHRightup, TxtY,[0-markShift,-y0], [0-markShift, 0]);//X文字标注
           /*****************************************************************************/ 
           makerjs.model.addPath(myKhHolesWMarkHRightup, new makerjs.paths.Line([0,0], [w, 0]));//X短标线
           makerjs.model.addCaption(myKhHolesWMarkHRightup, TxtW,[0,0+markShift], [w, 0+markShift]);//X文字标注
           /*****************************************************************************/ 
           //  //标记锁孔H位置孔左中
            var myKhHolesHLeftmd= new makerjs.models.Holes(d2/2, [[xh, yh+h]]);
                 var myKhHolesMarkHLeftmd = new makerjs.models.Square(0); //孔的原点       
                 myKhHolesMarkHLeftmd.origin = [xh, yh+h];      
                 var myKhHolesXMarkHLeftmd = new makerjs.models.Square(0);      
                 myKhHolesXMarkHLeftmd.origin =[xh, yh+h];      
                 var myKhHolesYMarkHLeftmd = new makerjs.models.Square(0);      
                 myKhHolesYMarkHLeftmd.origin = [xh, yh+h];  
           /*****************************************************************************/ 
           makerjs.model.addPath(myKhHolesMarkHLeftmd, new makerjs.paths.Line([0,0], [d2, -d2]));//直径标线
           makerjs.model.addCaption(myKhHolesMarkHLeftmd, TxtD2, [0,0], [d2+markHolesOneD, -d2-markHolesOneD]);//直径文字标注
           /*****************************************************************************/   
           makerjs.model.addPath(myKhHolesXMarkHLeftmd, new makerjs.paths.Line([0,0-h], [w, 0-h]));//X短标线
           makerjs.model.addCaption(myKhHolesXMarkHLeftmd, TxtW, [0,0-h+markShift], [w, 0-h+markShift]);//X文字标注
           /*****************************************************************************/     
           makerjs.model.addPath(myKhHolesYMarkHLeftmd, new makerjs.paths.Line([0,-h], [0, 0]));//H短标线
           makerjs.model.addCaption(myKhHolesYMarkHLeftmd, TxtH, [0+markShift,-h], [0+markShift, 0]);//H文字标注
           /*****************************************************************************/ 
           /*****************************************************************************/ 
            //标记锁孔H位置孔右下
            var myKhHolesHRightdn= new makerjs.models.Holes(d1/2, [[xh+w, yh]]);
                 var myKhHolesMarkHRightdn = new makerjs.models.Square(0); //孔的原点       
                 myKhHolesMarkHRightdn.origin = [xh+w, yh];      
           /*****************************************************************************/ 
           makerjs.model.addPath(myKhHolesMarkHRightdn, new makerjs.paths.Line([0,0], [d1, -d1]));//直径标线
           makerjs.model.addCaption(myKhHolesMarkHRightdn, TxtD1, [0,0], [d1+markHolesOneD, -d1-markHolesOneD]);//直径文字标注
           /*****************************************************************************/  
           plate.models["TypeHoles_KeyHole_HRightup"+myHolesNum]=myKhHolesHRightup;
           cutPlate.models["TypeHoles_KeyHole_HRightup"+myHolesNum]=myKhHolesHRightup;
           markers.models["TypeHoles_KeyHole_HRightup"+myHolesNum]=myKhHolesHRightup;
           markers.models["TypeHoles_KeyHole_MarkHRightup"+myHolesNum]=myKhHolesMarkHRightup;
           markers.models["TypeHoles_KeyHole_XMarkHRightup"+myHolesNum]=myKhHolesXMarkHRightup;
           markers.models["TypeHoles_KeyHole_WMarkHRightup"+myHolesNum]=myKhHolesWMarkHRightup;    
           /*****************************************************************************/
           plate.models["TypeHoles_KeyHole_HRightdn"+myHolesNum]=myKhHolesHRightdn;
           cutPlate.models["TypeHoles_KeyHole_HRightdn"+myHolesNum]=myKhHolesHRightdn;
           markers.models["TypeHoles_KeyHole_HRightdn"+myHolesNum]=myKhHolesHRightdn;
           markers.models["TypeHoles_KeyHole_MarkHRightdn"+myHolesNum]=myKhHolesMarkHRightdn;
           /*****************************************************************************/ 
           plate.models["TypeHoles_KeyHole_HLeftmd"+myHolesNum]=myKhHolesHLeftmd;
           cutPlate.models["TypeHoles_KeyHole_HLeftmd"+myHolesNum]=myKhHolesHLeftmd;
           markers.models["TypeHoles_KeyHole_HLeftmd"+myHolesNum]=myKhHolesHLeftmd;
           markers.models["TypeHoles_KeyHole_MarkHLeftmd"+myHolesNum]=myKhHolesMarkHLeftmd;
           markers.models["TypeHoles_KeyHole_XMarkHLeftmd"+myHolesNum]=myKhHolesXMarkHLeftmd;
           markers.models["TypeHoles_KeyHole_YMarkHLeftmd"+myHolesNum]=myKhHolesYMarkHLeftmd;
           /*****************************************************************************/ 
           /*****************************************************************************/ 
}
}else{      
      console.log("短边在X轴￥￥￥￥￥");
 if(area==4){
            //画孔 D位置孔
                 //标记锁孔D位置孔左上
                 var myKhHolesDLeftup= new makerjs.models.Holes(d1/2, [[xd, yd+w]]);
                 var myKhHolesMarkDLeftup = new makerjs.models.Square(0); //孔的原点       
                 myKhHolesMarkDLeftup.origin = [xd, yd+w];      
                 var myKhHolesXMarkDLeftup = new makerjs.models.Square(0);      
                 myKhHolesXMarkDLeftup.origin =[xd, yd+w];      
                 var myKhHolesYMarkDLeftup = new makerjs.models.Square(0);      
                 myKhHolesYMarkDLeftup.origin = [xd, yd+w]; 
           /*****************************************************************************/ 
           makerjs.model.addPath(myKhHolesMarkDLeftup, new makerjs.paths.Line([0,0], [d1, -d1]));//直径标线
           makerjs.model.addCaption(myKhHolesMarkDLeftup, TxtD1, [0,0], [d1+markHolesOneD, -d1-markHolesOneD]);//直径文字标注
           /*****************************************************************************/   
           makerjs.model.addPath(myKhHolesXMarkDLeftup, new makerjs.paths.Line([-x0,0], [0, 0]));//X短标线
           makerjs.model.addCaption(myKhHolesXMarkDLeftup, TxtX,[-x0,markShift], [0,markShift]);//X文字标注
           /*****************************************************************************/ 
           makerjs.model.addPath(myKhHolesYMarkDLeftup, new makerjs.paths.Line([0,-w], [0, 0]));//X短标线
           makerjs.model.addCaption(myKhHolesYMarkDLeftup, TxtW, [-markShift,-w], [-markShift, 0]);//X文字标注
           /*****************************************************************************/ 
           //  //标记锁孔D位置孔右中
            var myKhHolesDRightmd= new makerjs.models.Holes(d2/2, [[xd+h, yd]]);
                 var myKhHolesMarkDRightmd = new makerjs.models.Square(0); //孔的原点       
                 myKhHolesMarkDRightmd.origin = [xd+h, yd];      
                 var myKhHolesXMarkDRightmd = new makerjs.models.Square(0);      
                 myKhHolesXMarkDRightmd.origin =[xd+h, yd];      
                 var myKhHolesYMarkDRightmd = new makerjs.models.Square(0);      
                 myKhHolesYMarkDRightmd.origin = [xd+h, yd];  
           /*****************************************************************************/ 
           makerjs.model.addPath(myKhHolesMarkDRightmd, new makerjs.paths.Line([0,0], [d2, -d2]));//直径标线
           makerjs.model.addCaption(myKhHolesMarkDRightmd, TxtD2, [0,0], [d2+markHolesOneD, -d2-markHolesOneD]);//直径文字标注
           /*****************************************************************************/   
           makerjs.model.addPath(myKhHolesXMarkDRightmd, new makerjs.paths.Line([-h,-w], [-h, 0]));//X短标线
           makerjs.model.addCaption(myKhHolesXMarkDRightmd, TxtW, [-h-markShift,-w], [-h-markShift, 0]);//X文字标注
           /*****************************************************************************/     
           makerjs.model.addPath(myKhHolesYMarkDRightmd, new makerjs.paths.Line([-h,0], [0, 0]));//H短标线
           makerjs.model.addCaption(myKhHolesYMarkDRightmd, TxtH,[-h,-markShift], [0,-markShift]);//H文字标注
           /*****************************************************************************/ 
           /*****************************************************************************/ 
            //标记锁孔D位置孔左下
            var myKhHolesDLeftdn= new makerjs.models.Holes(d1/2, [[xd, yd-w]]);     
            var myKhHolesMarkDLeftdn = new makerjs.models.Square(0); //孔的原点       
            myKhHolesMarkDLeftdn.origin = [xd, yd-w];      
            makerjs.model.addPath(myKhHolesMarkDLeftdn, new makerjs.paths.Line([0,0], [d1, -d1]));//直径标线
           makerjs.model.addCaption(myKhHolesMarkDLeftdn, TxtD1, [0,0], [d1+markHolesOneD, -d1-markHolesOneD]);//直径文字标注
           /*****************************************************************************/ 
           plate.models["TypeHoles_KeyHole_DLeftup"+myHolesNum]=myKhHolesDLeftup;
           cutPlate.models["TypeHoles_KeyHole_DLeftup"+myHolesNum]=myKhHolesDLeftup;
           markers.models["TypeHoles_KeyHole_DLeftup"+myHolesNum]=myKhHolesDLeftup;
           markers.models["TypeHoles_KeyHole_MarkDLeftup"+myHolesNum]=myKhHolesMarkDLeftup;
           markers.models["TypeHoles_KeyHole_XMarkDLeftup"+myHolesNum]=myKhHolesXMarkDLeftup;
           markers.models["TypeHoles_KeyHole_YMarkDLeftup"+myHolesNum]=myKhHolesYMarkDLeftup;
           /*****************************************************************************/
           plate.models["TypeHoles_KeyHole_DLeftdn"+myHolesNum]=myKhHolesDLeftdn;
           cutPlate.models["TypeHoles_KeyHole_DLeftdn"+myHolesNum]=myKhHolesDLeftdn;
           markers.models["TypeHoles_KeyHole_DLeftdn"+myHolesNum]=myKhHolesDLeftdn;
           markers.models["TypeHoles_KeyHole_MarkDLeftdn"+myHolesNum]=myKhHolesMarkDLeftdn;
           /*****************************************************************************/ 
           plate.models["TypeHoles_KeyHole_DRightmd"+myHolesNum]=myKhHolesDRightmd;
           cutPlate.models["TypeHoles_KeyHole_DRightmd"+myHolesNum]=myKhHolesDRightmd;
           markers.models["TypeHoles_KeyHole_DRightmd"+myHolesNum]=myKhHolesDRightmd;
           markers.models["TypeHoles_KeyHole_MarkDRightmd"+myHolesNum]=myKhHolesMarkDRightmd;
           markers.models["TypeHoles_KeyHole_XMarkDRightmd"+myHolesNum]=myKhHolesXMarkDRightmd;
           markers.models["TypeHoles_KeyHole_YMarkDRightmd"+myHolesNum]=myKhHolesYMarkDRightmd;
           /*****************************************************************************/ 
          
 }else if(area==6){
           //画孔F位置孔
                 //标记锁孔F位置孔右上
                 var myKhHolesFRightup= new makerjs.models.Holes(d1/2, [[xf, yf+w]]);
                 var myKhHolesMarkFRightup = new makerjs.models.Square(0); //孔的原点       
                 myKhHolesMarkFRightup.origin = [xf, yf+w];      
                 var myKhHolesXMarkFRightup = new makerjs.models.Square(0);      
                 myKhHolesXMarkFRightup.origin =[xf, yf+w];      
                 var myKhHolesWMarkFRightup = new makerjs.models.Square(0);      
                 myKhHolesWMarkFRightup.origin =[xf, yf+w]; 
           /*****************************************************************************/ 
           /*****************************************************************************/ 
           makerjs.model.addPath(myKhHolesMarkFRightup, new makerjs.paths.Line([0,0], [d1, -d1]));//直径标线
           makerjs.model.addCaption(myKhHolesMarkFRightup, TxtD1, [0,0], [d1+markHolesOneD, -d1-markHolesOneD]);//直径文字标注
           /*****************************************************************************/   
           makerjs.model.addPath(myKhHolesXMarkFRightup, new makerjs.paths.Line([0,0], [x0, 0]));//X短标线
           makerjs.model.addCaption(myKhHolesXMarkFRightup, TxtX,[0,markShift], [x0,markShift]);//X文字标注
           /*****************************************************************************/ 
           makerjs.model.addPath(myKhHolesWMarkFRightup, new makerjs.paths.Line([0,-w], [0, 0]));//X短标线
           makerjs.model.addCaption(myKhHolesWMarkFRightup, TxtW,[-markShift,-w], [-markShift, 0]);//X文字标注
           /*****************************************************************************/ 
           //  //标记锁孔F位置孔左中
            var myKhHolesFLeftmd= new makerjs.models.Holes(d2/2, [[xf-h, yf]]);
                 var myKhHolesMarkFLeftmd = new makerjs.models.Square(0); //孔的原点       
                 myKhHolesMarkFLeftmd.origin = [xf-h, yf];      
                 var myKhHolesXMarkFLeftmd = new makerjs.models.Square(0);      
                 myKhHolesXMarkFLeftmd.origin =[xf-h, yf];      
                 var myKhHolesYMarkFLeftmd = new makerjs.models.Square(0);      
                 myKhHolesYMarkFLeftmd.origin = [xf-h, yf];  
           /*****************************************************************************/ 
           makerjs.model.addPath(myKhHolesMarkFLeftmd, new makerjs.paths.Line([0,0], [d2, -d2]));//直径标线
           makerjs.model.addCaption(myKhHolesMarkFLeftmd, TxtD2, [0,0], [d2+markHolesOneD, -d2-markHolesOneD]);//直径文字标注
           /*****************************************************************************/   
           makerjs.model.addPath(myKhHolesXMarkFLeftmd, new makerjs.paths.Line([h,0], [h, 0-w]));//X短标线
           makerjs.model.addCaption(myKhHolesXMarkFLeftmd, TxtW, [h-markShift,-w], [h-markShift, 0]);//X文字标注
           /*****************************************************************************/     
           makerjs.model.addPath(myKhHolesYMarkFLeftmd, new makerjs.paths.Line([0,0], [h, 0]));//H短标线
           makerjs.model.addCaption(myKhHolesYMarkFLeftmd, TxtH, [0,markShift], [h,markShift]);//H文字标注
           /*****************************************************************************/ 
           /*****************************************************************************/ 
            //标记锁孔F位置孔右下
            var myKhHolesFRightdn= new makerjs.models.Holes(d1/2, [[xf, yf-w]]);
                 var myKhHolesMarkFRightdn = new makerjs.models.Square(0); //孔的原点       
                 myKhHolesMarkFRightdn.origin = [xf, yf-w];      
           /*****************************************************************************/ 
           makerjs.model.addPath(myKhHolesMarkFRightdn, new makerjs.paths.Line([0,0], [d1, -d1]));//直径标线
           makerjs.model.addCaption(myKhHolesMarkFRightdn, TxtD1, [0,0], [d1+markHolesOneD, -d1-markHolesOneD]);//直径文字标注
           /*****************************************************************************/  
           plate.models["TypeHoles_KeyHole_FRightup"+myHolesNum]=myKhHolesFRightup;
           cutPlate.models["TypeHoles_KeyHole_FRightup"+myHolesNum]=myKhHolesFRightup;
           markers.models["TypeHoles_KeyHole_FRightup"+myHolesNum]=myKhHolesFRightup;
           markers.models["TypeHoles_KeyHole_MarkFRightup"+myHolesNum]=myKhHolesMarkFRightup;
           markers.models["TypeHoles_KeyHole_XMarkFRightup"+myHolesNum]=myKhHolesXMarkFRightup;
           markers.models["TypeHoles_KeyHole_WMarkFRightup"+myHolesNum]=myKhHolesWMarkFRightup;    
           /*****************************************************************************/
           plate.models["TypeHoles_KeyHole_FRightdn"+myHolesNum]=myKhHolesFRightdn;
           cutPlate.models["TypeHoles_KeyHole_FRightdn"+myHolesNum]=myKhHolesFRightdn;
           markers.models["TypeHoles_KeyHole_FRightdn"+myHolesNum]=myKhHolesFRightdn;
           markers.models["TypeHoles_KeyHole_MarkFRightdn"+myHolesNum]=myKhHolesMarkFRightdn;
           /*****************************************************************************/ 
           plate.models["TypeHoles_KeyHole_FLeftmd"+myHolesNum]=myKhHolesFLeftmd;
           cutPlate.models["TypeHoles_KeyHole_FLeftmd"+myHolesNum]=myKhHolesFLeftmd;
           markers.models["TypeHoles_KeyHole_FLeftmd"+myHolesNum]=myKhHolesFLeftmd;
           markers.models["TypeHoles_KeyHole_MarkFLeftmd"+myHolesNum]=myKhHolesMarkFLeftmd;
           markers.models["TypeHoles_KeyHole_XMarkFLeftmd"+myHolesNum]=myKhHolesXMarkFLeftmd;
           markers.models["TypeHoles_KeyHole_YMarkFLeftmd"+myHolesNum]=myKhHolesYMarkFLeftmd;
           /*****************************************************************************/ 
           /*****************************************************************************/ 
 }
}
  
/*****************************************************************************/ 

myHolesNum++;
return{plate,cutPlate, markers,myHolesNum}
};


export default KeyHole;